// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.85.0-beta.1f656612',
  revision: '1f656612',
  branch: 'develop',
  date: 'Fri, 06 Feb 2026 19:07:46 GMT'
};